module.exports = "<div class=\"lds-ring\">\n  <div [ngStyle]=\"styleColor()\"></div>\n  <div [ngStyle]=\"styleColor()\"></div>\n  <div [ngStyle]=\"styleColor()\"></div>\n  <div [ngStyle]=\"styleColor()\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/loading/loading.component.html
// module id = ./src/app/components/loading/loading.component.html
// module chunks = main